"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoFocusDisabledReducer = autoFocusDisabledReducer;
var _autoFocusDisabled = require("../../actions/autoFocusDisabled");
function autoFocusDisabledReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _autoFocusDisabled.EAutoFocusDisabledActionTypes.SetAutoFocusDisabled:
      return action.payload;
  }
  return state;
}